/**
 * User Actions Logger for Frontend
 * Sends log entries to backend for tracking notification system interactions
 */

import { user_actions_logs } from '../routes'

export class UserActionsLogger {
  /**
   * Log an action from the frontend
   * @param {string} entry - Description of the action
   * @param {Object} data - Additional data to attach (optional)
   * @param {string} ecosystemId - Ecosystem ID (optional, will try to get from meta tag)
   */
  static async log (entry, data = {}, ecosystemId = null) {
    try {
      const ecosystem = ecosystemId || document.querySelector('meta[name="ecosystem_id"]')?.content

      if (!ecosystem) {
        console.warn('[UserActionsLogger] No ecosystem_id found, skipping log')
        return
      }

      // Capture client-side UTC timestamp at the moment of logging
      const clientTimestamp = new Date().toISOString()

      const response = await fetch(user_actions_logs(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
        },
        body: JSON.stringify({
          entry,
          data,
          ecosystem_id: ecosystem,
          source: 'frontend',
          client_timestamp: clientTimestamp
        })
      })

      if (!response.ok) {
        console.error('[UserActionsLogger] Failed to log action:', response.status)
      }
    } catch (err) {
      console.error('[UserActionsLogger] Error logging action:', err)
    }
  }

  /**
   * Log Firebase notification action
   */
  static logFirebase (action, data = {}) {
    return this.log(`Firebase: ${action}`, { ...data, token_type: 'firebase' })
  }

  /**
   * Log Declarative Web Push action
   */
  static logWebPush (action, data = {}) {
    return this.log(`WebPush: ${action}`, { ...data, token_type: 'declarative_web_push' })
  }
}
